/* kt-soru: "Ürün Hakkında Soru Sor" penceresi (snippets/kt-soru-modal.liquid).
   Açma: [data-kt-soru-ac]; kapatma: [data-kt-soru-kapat], Esc. Gönderim Shopify iletişim formuna (/contact) sayfadan
   ayrılmadan yapılır; Shopify doğrulama ekranı (/challenge) isterse form normal gönderilir ve dönüşte başarı durumu açılır. */
(function () {
  var kok = document.querySelector('[data-kt-soru]');
  if (!kok) return;
  var form = kok.querySelector('form');
  var metin = kok.querySelector('[data-kt-soru-metin]');
  var eposta = kok.querySelector('[data-kt-soru-eposta]');
  var sayac = kok.querySelector('[data-kt-soru-sayac]');
  var gonder = kok.querySelector('[data-kt-soru-gonder]');
  var gonderYazi = gonder.querySelector('span');
  var hata = kok.querySelector('[data-kt-soru-hata]');
  var alan = kok.querySelector('[data-kt-soru-form-alan]');
  var tamam = kok.querySelector('[data-kt-soru-tamam]');
  var link = kok.querySelector('[data-kt-soru-link]');
  var BAYRAK = 'kt-soru-bekliyor';
  var sonOdak = null;
  var gidiyor = false;

  function bayrak(deger) {
    try {
      if (deger === undefined) return sessionStorage.getItem(BAYRAK);
      if (deger) sessionStorage.setItem(BAYRAK, deger); else sessionStorage.removeItem(BAYRAK);
    } catch (_) { return null; }
  }

  function guncelle() {
    sayac.textContent = metin.value.length + '/500';
    gonder.disabled = gidiyor || !(metin.value.trim() && eposta.value.trim());
  }

  function ac() {
    sonOdak = document.activeElement;
    kok.hidden = false;
    document.documentElement.classList.add('kt-soru-kilit');
    setTimeout(function () {
      (tamam.hidden ? metin : tamam.querySelector('button')).focus();
    }, 30);
  }

  function kapat() {
    kok.hidden = true;
    document.documentElement.classList.remove('kt-soru-kilit');
    if (!tamam.hidden) {
      form.reset();
      tamam.hidden = true;
      alan.hidden = false;
      guncelle();
    }
    if (sonOdak && sonOdak.focus) sonOdak.focus();
  }

  function basarili() {
    hata.hidden = true;
    alan.hidden = true;
    tamam.hidden = false;
  }

  function mesgul(evet) {
    gidiyor = evet;
    gonderYazi.textContent = evet ? 'Gönderiliyor...' : 'Soruyu Gönder';
    guncelle();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-kt-soru-ac]');
    if (!t) return;
    e.preventDefault();
    ac();
  });
  Array.prototype.forEach.call(kok.querySelectorAll('[data-kt-soru-kapat]'), function (b) {
    b.addEventListener('click', kapat);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !kok.hidden) kapat();
  });
  metin.addEventListener('input', guncelle);
  eposta.addEventListener('input', guncelle);

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (gidiyor || !form.reportValidity()) return;
    link.value = location.href.split('#')[0];
    hata.hidden = true;
    mesgul(true);
    fetch(form.getAttribute('action') || '/contact', {
      method: 'POST',
      body: new URLSearchParams(new FormData(form)),
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    }).then(function (r) {
      var u = r.url || '';
      if (/[?&]contact_posted=true/.test(u)) { mesgul(false); basarili(); return; }
      if (/\/challenge/.test(u)) { bayrak(location.pathname); form.submit(); return; }
      throw new Error('gonderilemedi');
    }).catch(function () {
      mesgul(false);
      hata.hidden = false;
    });
  });

  // Doğrulama ekranından (/challenge) dönüş: Shopify ?contact_posted=true ile bu sayfaya döner. Sonucu sayfadaki iki
  // iletişim formuna da işlediği için yorum formunun teşekkür kutusu kaldırılır ve yorum paneli kapalı tutulur.
  var bekleyen = bayrak();
  if (bekleyen) {
    bayrak(null);
    if (bekleyen === location.pathname && /[?&]contact_posted=true/.test(location.search)) {
      var yorumPanel = document.querySelector('[data-kt-review-panel]');
      if (yorumPanel) {
        Array.prototype.forEach.call(yorumPanel.querySelectorAll('[data-kt-review-open]'), function (el) { el.parentNode.removeChild(el); });
        yorumPanel.hidden = true;
        var yorumBtn = document.querySelector('[data-kt-review-toggle]');
        if (yorumBtn) yorumBtn.setAttribute('aria-expanded', 'false');
      }
      basarili();
      ac();
      if (window.history && history.replaceState) {
        history.replaceState(null, '', location.pathname + location.search.replace(/([?&])contact_posted=true&?/, '$1').replace(/[?&]$/, ''));
      }
    }
  }
  guncelle();
})();
